import script from "./StepImages.vue?vue&type=script&setup=true&lang=js"
export * from "./StepImages.vue?vue&type=script&setup=true&lang=js"

import "./StepImages.vue?vue&type=style&index=0&id=53d54d54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d54d54"]])

export default __exports__